import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from 'interfaces/paginate-duck';
import { User } from 'interfaces/user';

const { Types, Creators } = createActions(
  {
    request: ['query'],
    success: ['data', 'pagination'],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'PAGINATE_USER_ROLES_' }
);

export interface PaginateUserRolesState extends IState {
  data: User[] | Record<string, any>[];
}

const INITIAL_STATE: PaginateUserRolesState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateUserRolesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateUserRolesState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateUserRolesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateUserRoles = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateUserRolesTypes = Types;
export const PaginateUserRolesActions = Creators;
